import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { isEmpty, slice } from 'ramda';
import Button from '@components/@core/AnimatedButton';
import { history } from '~/reducers';
import { CommunityActions, AppActions } from '~/actions';
import EmptyPeople from './EmptyPeople';
import PeopleItem from './PeopleItem';

const VendorSearchPeople = ({ data, type, onSeeAll }) => {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.app.token);
    const { community_user } = useSelector((state) => state.app.user);
    const subs = data.length > 3 ? slice(0, 3, data) : data;

    const handleConnectCallBack = () => {
        toast.success('Connection Request has been sent', {
            position: toast.POSITION.TOP_RIGHT,
            pauseOnFocusLoss: false,
            hideProgressBar: true,
        });
        dispatch(AppActions.fetchnotificationsRequest());
    };

    const handleOpenDetail = (e) => () => {
        window.location = `/${e?.entity?.slug}/about`;
    };

    const handleConnect = (e) => () => {
        const route = history.location.pathname;
        const payload = { user_id: community_user?.id, connect_user_id: e?.id };
        const after = { type: 'GETUSERCONNECTIONS_REQUEST' };
        if (token) {
            dispatch(CommunityActions.postcommunityconnectRequest(payload, null, after, handleConnectCallBack));
        } else {
            dispatch(
                AppActions.modalRequest({
                    type: 'Authentication',
                    data: {
                        before: {
                            route,
                            after: {
                                type: 'POSTCOMMUNITYCONNECT_REQUEST',
                                payload,
                                route: null,
                                after,
                                callback: handleConnectCallBack,
                            },
                        },
                    },
                })
            );
        }
    };

    return (
        <div className="vendor-search-people">
            <div className="d-h-start">
                <p className="dsl-b18 bold me-2">People</p>
                <p className="dsl-p12">{`(${data.length})`}</p>
            </div>
            {isEmpty(data) ? (
                <EmptyPeople />
            ) : (
                <>
                    {type === 'sub' ? (
                        <div className="border-bottom pb-3 mb-5">
                            <Row className="mx-0">
                                {subs.map((people) => {
                                    const { id, first_name, last_name, profile, stats } = people;
                                    const connects = stats && stats.connections ? stats.connections : 0;
                                    return (
                                        <Col className="px-0" xs={12} sm={6} md={4} key={`people-${id}`}>
                                            <PeopleItem
                                                name={`${first_name} ${last_name}`}
                                                job={profile?.job_title}
                                                connects={connects}
                                                onClick={handleOpenDetail(people)}
                                                onConnect={handleConnect(people)}
                                            />
                                        </Col>
                                    );
                                })}
                            </Row>
                            <div className="d-h-end">
                                <Button type="link" name="SEE ALL" onClick={onSeeAll} />
                            </div>
                        </div>
                    ) : (
                        <Row className="mx-0">
                            {data.map((people) => {
                                const { id, first_name, last_name, profile, stats } = people;
                                const connects = stats && stats.connections ? stats.connections : 0;
                                return (
                                    <Col className="px-0" xs={12} sm={6} md={3} key={`people-${id}`}>
                                        <PeopleItem
                                            name={`${first_name} ${last_name}`}
                                            job={profile?.job_title}
                                            connects={connects}
                                            onClick={handleOpenDetail(people)}
                                            onConnect={handleConnect(people)}
                                        />
                                    </Col>
                                );
                            })}
                        </Row>
                    )}
                </>
            )}
        </div>
    );
};

VendorSearchPeople.propTypes = {
    data: PropTypes.array,
    type: PropTypes.oneOf(['sub', 'full']),
    onSeeAll: PropTypes.func,
};

VendorSearchPeople.defaultProps = {
    data: [],
    type: 'sub',
    onSeeAll: () => {},
};

export default memo(VendorSearchPeople);
